<template>
  <div class="d-flex">
    <FormError
      class="my-auto mr-3"
      :error="getRequestError()"
    />

    <h6 class="my-auto">
      Export:&nbsp;
    </h6>

    <div
      class="btn-group my-auto"
      role="group"
    >
      <BasicButton
        class="btn-dark"
        :isProcessing="extension === 'csv'"
        :disabled="isProcessing"
        @click="() => onClick('csv')"
      >
        CSV
      </BasicButton>

      <BasicButton
        class="btn-dark"
        :isProcessing="extension === 'xls'"
        :disabled="isProcessing"
        @click="() => onClick('xls')"
      >
        Excel
      </BasicButton>
    </div>
  </div>
</template>

<script>
  import RequestMixin from '@/mixins/RequestMixin'

  import AdminAPI from '@/api/AdminAPI'

  import BasicButton from '@/components/BasicButton'
  import FormError from '@/components/FormError'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      BasicButton,
      FormError,
    },

    data() {
      return {
        extension: null,
      }
    },

    methods: {
      async exportVoucherCodes() {
        return await AdminAPI.exportVoucherCodes({
          extension: this.extension,
        })
      },

      async onClick(extension) {
        this.extension = extension

        await this.handleRequest(this.exportVoucherCodes)

        this.extension = null
      },
    },
  }
</script>

<style>

</style>
